<template>
  <div>
    <Breadcrumb msg1="视光诊疗" msg2="视功能检查" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-select v-model="query.customer_id" filterable remote placeholder="按客户搜索" :remote-method="searchCustomer" clearable style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="query.check_type" placeholder="检查类型" clearable>
            <el-option label="调节功能" value="调节功能"></el-option>
            <el-option label="集合功能" value="集合功能"></el-option>
            <el-option label="双眼视" value="双眼视"></el-option>
            <el-option label="色觉" value="色觉"></el-option>
            <el-option label="立体视" value="立体视"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="检查日期" prop="checkDate" width="110"></el-table-column>
        <el-table-column label="类型" prop="checkType" width="90"></el-table-column>
        <el-table-column label="检查结论" prop="vfConclusion" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column label="异常原因" prop="vfReason" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column label="AC/A" prop="aca" width="80"></el-table-column>
        <el-table-column label="集合近点" prop="npc" width="90"></el-table-column>
        <el-table-column label="结果分析" prop="resultAnalysis" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="900px" :close-on-click-modal="false">
      <el-form :model="form" label-width="110px" v-if="show">
        <el-divider content-position="left">基本信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户" required>
              <el-select v-model="form.customerId" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
                <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="检查日期"><el-date-picker v-model="form.checkDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="检查类型">
              <el-select v-model="form.checkType" style="width: 100%">
                <el-option label="调节功能" value="调节功能"></el-option>
                <el-option label="集合功能" value="集合功能"></el-option>
                <el-option label="双眼视" value="双眼视"></el-option>
                <el-option label="色觉" value="色觉"></el-option>
                <el-option label="立体视" value="立体视"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结果">
              <el-select v-model="form.result" style="width: 100%">
                <el-option label="正常" value="正常"></el-option>
                <el-option label="异常" value="异常"></el-option>
                <el-option label="临界" value="临界"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医生">
              <el-select v-model="form.doctorId" style="width: 100%">
                <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">眼位与隐斜</el-divider>
        <el-row>
          <el-col :span="12"><el-form-item label="主导眼"><el-input v-model="form.dominantEye"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远隐斜"><el-input v-model="form.phoriaFar"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近隐斜"><el-input v-model="form.phoriaNear"></el-input></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">调节功能</el-divider>
        <el-row>
          <el-col :span="12"><el-form-item label="远调节储备1"><el-input v-model="form.accReserveFar1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远调节储备2"><el-input v-model="form.accReserveFar2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近调节储备1"><el-input v-model="form.accReserveNear1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近调节储备2"><el-input v-model="form.accReserveNear2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="调节灵活度1"><el-input v-model="form.accFlexibility1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="调节灵活度2"><el-input v-model="form.accFlexibility2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="放松值"><el-input v-model="form.relaxation"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="OD放松"><el-input v-model="form.relaxationOd"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="OS放松"><el-input v-model="form.relaxationOs"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="PRA"><el-input v-model="form.pra"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="NRA"><el-input v-model="form.nra"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="OD调节幅度"><el-input v-model="form.amplitudeOd"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="OS调节幅度"><el-input v-model="form.amplitudeOs"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="双眼调节幅度"><el-input v-model="form.amplitudeBin"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="OD调节力"><el-input v-model="form.powerOd"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="OS调节力"><el-input v-model="form.powerOs"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="双眼调节力"><el-input v-model="form.powerBin"></el-input></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">融像功能</el-divider>
        <el-row>
          <el-col :span="12"><el-form-item label="远融像储备1"><el-input v-model="form.fusionReserveFar1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远融像储备2"><el-input v-model="form.fusionReserveFar2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远融像储备3"><el-input v-model="form.fusionReserveFar3"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远融像储备4"><el-input v-model="form.fusionReserveFar4"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近融像储备1"><el-input v-model="form.fusionReserveNear1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近融像储备2"><el-input v-model="form.fusionReserveNear2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近融像储备3"><el-input v-model="form.fusionReserveNear3"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近融像储备4"><el-input v-model="form.fusionReserveNear4"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远垂直集合1"><el-input v-model="form.verticalAccFar1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远垂直集合2"><el-input v-model="form.verticalAccFar2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近垂直集合1"><el-input v-model="form.verticalAccNear1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近垂直集合2"><el-input v-model="form.verticalAccNear2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远垂直融像1"><el-input v-model="form.verticalFusionFar1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="远垂直融像2"><el-input v-model="form.verticalFusionFar2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近垂直融像1"><el-input v-model="form.verticalFusionNear1"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="近垂直融像2"><el-input v-model="form.verticalFusionNear2"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BI远模糊点"><el-input v-model="form.biFarBlur"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BI远破裂点"><el-input v-model="form.biFarBreak"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BI远恢复点"><el-input v-model="form.biFarRecover"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BI近模糊点"><el-input v-model="form.biNearBlur"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BI近破裂点"><el-input v-model="form.biNearBreak"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BI近恢复点"><el-input v-model="form.biNearRecover"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BO远模糊点"><el-input v-model="form.boFarBlur"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BO远破裂点"><el-input v-model="form.boFarBreak"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BO远恢复点"><el-input v-model="form.boFarRecover"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BO近模糊点"><el-input v-model="form.boNearBlur"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BO近破裂点"><el-input v-model="form.boNearBreak"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="BO近恢复点"><el-input v-model="form.boNearRecover"></el-input></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">立体视与集合</el-divider>
        <el-row>
          <el-col :span="12"><el-form-item label="CISS"><el-input v-model="form.ciss"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="立体视"><el-input v-model="form.stereoVision"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="AC/A"><el-input v-model="form.aca"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="AC/A测量法"><el-input v-model="form.acaMethod"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="集合近点"><el-input v-model="form.npc"></el-input></el-form-item></el-col>
        </el-row>

        <el-divider content-position="left">结论分析</el-divider>
        <el-row>
          <el-col :span="12"><el-form-item label="检查结论"><el-input v-model="form.vfConclusion"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="异常原因"><el-input v-model="form.vfReason"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="主觉结论"><el-input v-model="form.subjectiveConclusion"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="综合结论"><el-input v-model="form.conclusion"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="结果分析"><el-input v-model="form.resultAnalysis" type="textarea"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, customer_id: null, check_type: '', result: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      customerOptions: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
  },
  methods: {
    customerName,
    buildEmptyForm () {
      return {
        customerId: null,
        checkDate: '',
        checkType: '调节功能',
        item: '',
        odValue: '',
        osValue: '',
        result: '正常',
        doctorId: null,
        conclusion: '',
        remark: '',
        dominantEye: '',
        phoriaFar: '',
        phoriaNear: '',
        accReserveFar1: '',
        accReserveFar2: '',
        accReserveNear1: '',
        accReserveNear2: '',
        accFlexibility1: '',
        accFlexibility2: '',
        relaxation: '',
        relaxationOd: '',
        relaxationOs: '',
        pra: '',
        nra: '',
        amplitudeOd: '',
        amplitudeOs: '',
        amplitudeBin: '',
        powerOd: '',
        powerOs: '',
        powerBin: '',
        fusionReserveFar1: '',
        fusionReserveFar2: '',
        fusionReserveFar3: '',
        fusionReserveFar4: '',
        fusionReserveNear1: '',
        fusionReserveNear2: '',
        fusionReserveNear3: '',
        fusionReserveNear4: '',
        verticalAccFar1: '',
        verticalAccFar2: '',
        verticalAccNear1: '',
        verticalAccNear2: '',
        verticalFusionFar1: '',
        verticalFusionFar2: '',
        verticalFusionNear1: '',
        verticalFusionNear2: '',
        biFarBlur: '',
        biFarBreak: '',
        biFarRecover: '',
        biNearBlur: '',
        biNearBreak: '',
        biNearRecover: '',
        boFarBlur: '',
        boFarBreak: '',
        boFarRecover: '',
        boNearBlur: '',
        boNearBreak: '',
        boNearRecover: '',
        ciss: '',
        stereoVision: '',
        aca: '',
        acaMethod: '',
        npc: '',
        vfConclusion: '',
        vfReason: '',
        subjectiveConclusion: '',
        resultAnalysis: ''
      }
    },
    getData () {
      this.$axios.get('/visionFunctions', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    add () {
      this.dialogTitle = '新增视功能检查'
      this.form = this.buildEmptyForm()
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑视功能检查'
      // 响应即 camelCase 实体，与表单键一致，直接合并
      this.form = Object.assign(this.buildEmptyForm(), row)
      this.customerOptions = [{ id: row.customerId, name: customerName(row.customerId), phone: '' }]
      this.show = true
    },
    save () {
      if (!this.form.customerId) { this.$message.warning('请选择客户'); return }
      if (this.form.id) {
        this.$axios.put(`/visionFunctions/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/visionFunctions', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/visionFunctions/${id}`, () => this.getData())
    }
  }
}
</script>
